import React from 'react'
import Spinner from 'react-bootstrap/Spinner'
import { useTranslation } from '../i18n/TranslationProvider'

const LoadingSpinner = () => {
  const { t } = useTranslation()
  return (
    <Spinner className="d-block" animation="border" role="status">
      <span className="sr-only">{t("common.loading")}</span>
    </Spinner>
  )
}

export default LoadingSpinner